import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledAutocompleteFieldPaper from 'components/molecules/Fields/AutocompleteField/AutocompleteFieldPaper.styles';

const AutocompleteFieldPaper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps({
    elevation: 6,
    size: 'medium',
    ...props
  }, 'AutocompleteFieldPaper');

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledAutocompleteFieldPaper ref={ref} {...innerProps} />
});

AutocompleteFieldPaper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default AutocompleteFieldPaper;
